import React, { Component, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { commonActions, bundleActions } from '../../../../store/actions'

import BundleList from './BundleList'
import queryString from 'query-string'
import Pagination from '../../../../module/pagination-box'
import history from '../../../../route/history'

const Bundle = (props) => {
  const [state, setState] = useState({
    searchWord: '',
    pageIdx: 0,
    isShowMessage: false, //메시지 알럿창 활성화여부
  })

  const [pagingInfo, setPagingInfo] = useState({})

  useEffect(() => {
    const query = queryString.parse(history.location.search)
    //console.log('query = ', query);

    if (Object.keys(query).length > 0) {
      props.settingHistory(query)
      setState(query)
    } else {
      searchList()
    }
  }, [])
  
  useEffect(() => {
    const tRs = props.BundleList?.totalElements ? props.BundleList?.totalElements : 0
    const tPage = Math.ceil(tRs / 10)

    setPagingInfo({
      totalRecords: props.BundleList?.totalElements ? props.BundleList?.totalElements : 0,
      currentPage: state.pageIdx ? parseInt(state.pageIdx) + 1 : 1,
      pageNumber: props.BundleList?.pageable?.pageNumber,
      totalPage: tPage,
      pagesToShow: 10,
    })
  }, [props.BundleList])

  useEffect(() => {
    if (!props.history) return
    const idx = props.history?.pageIdx ? props.history?.pageIdx : 0
    searchList(idx)
  }, [props.history])

  const searchList = (index = 0) => {
    let searchInfo = {}
    const { searchWord, pageIdx } = state
    searchWord?.length > 0 && (searchInfo = { searchWord, pageIdx })
    index > 0 && (searchInfo = { searchWord, pageIdx })
    //console.log('searchInfo = ', searchInfo);

    setState({
      ...state,
      searchInfo,
    })

    let paramStr = queryString.stringify(searchInfo)
    paramStr.length > 0 && (paramStr = '?' + paramStr)
    //history.push('/service/bundle' + paramStr)

    props.readBundleList(searchInfo)
  }

  const onBundleDetail = (bundle) => {
    props.selectBundleInfo(bundle) // 선택한 대상의 정보 셋팅
    history.push({ pathname: '/service/bundle/detail/' + bundle.packageId, state: state })
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      searchList()
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setState({
      [name]: value,
    })
  }

  useEffect(() => {
    //searchList()
  }, [state.searchWord])

  const prePage = (e) => {
    e.preventDefault()
    history.goBack()
  }
  return (
    <>
      {/* contents */}
      <div id="contents">
        <div className="content-header">
          <a href="#" onClick={prePage} className="page-prev">
            뒤로이동
          </a>
          {/* mobile */}
          <h2>꾸러미 신청</h2>
          <div className="breadcrumb">
            <span>Home</span>
            <span>꾸러미 신청</span>
            <em>꾸러미 신청</em>
          </div>
        </div>
        <div className="search-box center">
          <div className="row">
            <span className="tit">검색어</span>
            <div className="inquiry-group">
              <input
                type="text"
                placeholder="꾸러미명을 입력하세요."
                className="form-keyword"
                id="searchWord"
                name="searchWord"
                value={state.searchWord || ''}
                onChange={handleChange}
                onKeyPress={handleKeyPress}
              />
              <button className="btn-search" onClick={searchList}>
                검색
              </button>
            </div>
          </div>
        </div>
        <div className="list-header">
          <span className="total-num">
            현재페이지 <em>{pagingInfo?.currentPage}</em>/{pagingInfo?.totalPage} {pagingInfo?.totalRecords}건
          </span>
          <span className="right">
            <em className="filter"></em>
          </span>
        </div>
        <BundleList
          data={props.BundleList?.content}
          commoncode={props.commoncode}
          onBundleDetail={onBundleDetail}
          reload={props.readBundleList}
        />
        <div className="list-footer">
          <Pagination pagingInfo={pagingInfo} onChange={(param) => searchList(param - 1)} />
        </div>
      </div>
      {/* //contents */}
      {/* 알림 */}
      {state.isShowMessage === true && (
        <div id="notify-message" className="modal notify-message">
          <div className="modal-head">
            <h2>알림</h2>
          </div>
          <div className="modal-cont">
            <p className="message">
              정부24 회원가입 시 휴대폰 본인인증을 하지 않으셨거나 휴대폰 인증을 하였지만 이후 휴대폰 번호를 바꾸었을 때 나오는
              메시지입니다.
              <br />
              <br />
              정부24앱 메뉴 <strong>‘MyGov → 회원정보 → 회원정보 관리’</strong>에서 회원정보 수정 화면의 휴대전화번호 항목 옆
              <br />
              <strong>'휴대폰 본인확인’ 버튼을 선택</strong>하여 진행 후<br />
              다시 한 번 전자문서를 발급 받으시기 바랍니다.
            </p>
            <div className="btn-block center">
              <a href="#" className="btn-primary md b-close">
                확인
              </a>
            </div>
          </div>
          <button type="button" className="modal-close b-close">
            창닫기
          </button>
          <div className="today-close">
            <input type="checkbox" id="today-close" />
            <em />
            <label htmlFor="today-close">오늘 하루 열지 않기</label>
          </div>
        </div>
      )}
      {/* //알림 */}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    soloSelectInfo: state.bundle?.selectInfo,
    BundleList: state.bundle?.BundleList?.list,
    countInfo: state.bundle?.BundleList?.count,
    commoncode: state.commoncode?.co,
    history: state.bundle?.history,
  }
}

const actionCreators = {
  changeSearchInfo: bundleActions.changeSearchInfo,
  readBundleList: bundleActions.readBundleList,
  selectBundleInfo: bundleActions.selectBundleInfo,
  common: commonActions.getCommonCode,
  settingHistory: bundleActions.settingHistory,
}

export default connect(mapStateToProps, actionCreators)(Bundle)
